export var modalBreakpointValue = "medium";
export var modalBackgroundColor = "backgroundLight";